import { render } from "./Select2.vue?vue&type=template&id=3adad2cc&scoped=true"
import script from "./Select2.vue?vue&type=script&lang=js"
export * from "./Select2.vue?vue&type=script&lang=js"

import "./Select2.vue?vue&type=style&index=0&id=3adad2cc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3adad2cc"]])

export default __exports__